var _rect, _rect2, _path, _g, _rect3, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.666748,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#145B67"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19182)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11.667 11.6667)",
    fill: "#FF7140"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_19182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.667 11.6667H11.667V35.6667H35.667V11.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_19182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1939 11.765C18.6202 10.925 12.6082 15.5652 11.7652 22.1397C10.9252 28.7135 15.5655 34.7255 22.1399 35.5685C28.7137 36.4085 34.7257 31.7682 35.5649 25.1937C36.4087 18.62 31.7692 12.608 25.1939 11.765ZM27.6629 19.253C27.4402 19.253 27.2287 19.343 27.0727 19.5027L22.6199 23.9517L22.3117 23.6465L21.6704 23.0022C26.0572 18.6275 26.8507 18.584 27.6622 19.2522L27.6629 19.253ZM22.8037 24.1115L27.2407 19.6707C27.4867 19.4127 27.8969 19.4165 28.1437 19.6745C28.3859 19.9362 28.3619 20.3465 28.0889 20.5722L23.3902 24.6972L22.8037 24.1115ZM23.1322 24.8075L22.0304 25.0452C22.0072 25.049 21.9764 25.037 21.9644 25.01C21.9524 24.986 21.9562 24.959 21.9764 24.9387L22.6207 24.2945L23.1322 24.8075ZM20.3272 24.347L21.5032 23.1747L22.3822 24.0537L20.4015 24.479C20.3662 24.4872 20.3317 24.4722 20.3152 24.44C20.2965 24.4092 20.304 24.3702 20.3272 24.347ZM16.683 30.4047C16.6402 30.401 16.608 30.362 16.6117 30.323C16.6155 30.3042 16.6237 30.2877 16.6357 30.2757H16.6395L17.5845 29.3307L18.8077 30.554L16.683 30.4047ZM19.1077 29.147C19.0147 29.198 18.9675 29.3037 18.9907 29.405L19.194 30.269C19.2262 30.3942 19.0732 30.479 18.9832 30.386H18.9795L17.7532 29.159L21.5152 25.4007L23.3354 25.007L24.2062 25.8822C22.9522 26.9832 21.2362 28.0812 19.1077 29.147ZM24.3862 25.7217L23.5462 24.8817L28.2449 20.7567C28.2877 20.7177 28.3267 20.675 28.3619 20.6315C28.2179 21.9755 26.3347 23.8737 24.3862 25.7217ZM28.0462 19.2605H28.0424C26.4052 17.6157 28.7182 15.0882 30.4994 16.5725L28.8907 18.1865C28.8434 18.2322 28.8434 18.3117 28.8907 18.3575L30.1364 19.6047C29.4374 19.952 28.5974 19.8117 28.0462 19.2605ZM30.6202 19.2605C30.5384 19.3422 30.4484 19.4165 30.3509 19.4787L29.1442 18.272L30.6749 16.7367C31.3387 17.4597 31.3117 18.569 30.6202 19.2605ZM30.5219 17.7177C30.4717 17.753 30.4522 17.8145 30.4679 17.8737C30.5422 18.0215 30.5219 18.1977 30.4169 18.323C30.3659 18.386 30.3779 18.4722 30.4402 18.5217C30.4642 18.5375 30.4912 18.5495 30.5219 18.5495C30.5647 18.5495 30.6052 18.5337 30.6277 18.5022C30.8039 18.2915 30.8384 17.9945 30.7177 17.7485C30.6704 17.6862 30.5849 17.6705 30.5219 17.7177Z",
    fill: "white"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11.667 11.6667)",
    fill: "#145B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8507 15.6667H14.4833C14.0325 15.6667 13.667 16.0322 13.667 16.4831V30.8504C13.667 31.3012 14.0325 31.6667 14.4833 31.6667H32.8507C33.3015 31.6667 33.667 31.3012 33.667 30.8504V16.4831C33.667 16.0322 33.3015 15.6667 32.8507 15.6667Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 21.1407C18.667 19.6667 16.9159 20.6355 17.0414 22.1511C17.167 23.6667 19.167 23.6667 19.2919 25.1823C19.4168 26.698 17.667 27.6667 16.667 26.1927",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 20.6667H22.667V27.1667H24.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 24.1667H24.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 22.1667C30.667 21.3383 29.9954 20.6667 29.167 20.6667C28.3386 20.6667 27.667 21.3383 27.667 22.1667V25.6667C27.667 26.4951 28.3386 27.1667 29.167 27.1667C29.9954 27.1667 30.667 26.4951 30.667 25.6667V22.1667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11.667 11.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech8);
export default __webpack_public_path__ + "static/media/careerTech8.efef3fcdcd24dec188e3cbf2f93582f6.svg";
export { ForwardRef as ReactComponent };